export default __webpack_public_path__ + "static/media/pool-explorer.f1eece8d.svg";